import { Category } from "../../Models/Category";
import { Subcategory } from "../../Models/SubCategory";
import { CategoryAPIHandler } from "../../services/NetworkClient/BackendAPIs/CategoryAPIHandler";

const categoriesAPIHandler = new CategoryAPIHandler()

export interface CategoryAndSubcategoryMap {
    category: Category,
    subcategories: Subcategory[]
}

export const fetchCategories = async () : Promise<CategoryAndSubcategoryMap[]> => {
    try {
        let categoriesResponse = await categoriesAPIHandler.getAllCategoriesWithSubcategories()
        return Promise.resolve(categoriesResponse.categories);
    } catch (err) {
        return Promise.reject(err);
    }
}
